/**
 * The description copy for each service.
 */
export const SERVICES_DESCRIPTIONS = {
  'News Shooter / Video Journalist': {
    description: 'Experienced journalist capable of shooting and producing news stories.',
    select: 'Select if you are looking for one person who can handle all aspects of production with a quick turn around.',
  },
  'Documentary DP': {
    description: 'Director of photography with experience in short or long form documentary productions.',
    select: 'Select if you are looking for documentary style character-driven, cinematic storytelling.',
  },
  'Commercial DP': {
    description: 'Director of photography with experience shooting ad spots in the field or on set.',
    select: 'Select if you need a versatile DP capable of shooting small or large budget commercials.',
  },
  'Corporate Videographer': {
    description: 'A videographer who specializes in producing content for companies and corporations, at events, panels or other engagements.',
    select: 'Select if you need a videographer for a corporate shoot or event for your business.',
  },
  'Drone Operator': {
    description: 'Professional drone operator for aerial photography and videography.',
    select: 'Select if your project needs stunning pictures or video from the sky - can combine with any other service.',
  },
  'Production Company': {
    description: 'Production company that handles all aspects of production and crewing.',
    select: 'Select if you want to be completely hands off and just receive a finished video.',
  },
  'Line Producer / On-Location': {
    description: 'Line Producers handle all day-to-day aspects of on-location field production, including budgeting, crewing and dealing with logistical issues that come up during the shoot. They often are the first person you hire for a remote shoot or film.',
    select: 'Select if you need someone to handle all the on-location logistics and crewing for a project.',
  },
  'Senior Producer / Project Manager': {
    description: 'Senior producers are skilled project managers who can handle all aspects of crewing, budgeting, production management, editorial direction and will oversee the production and can work directly with the client.',
    select: 'Select if you need a highly experienced producers who you can trust for all aspects of production and development.',
  },
  'Series Producer / Show Runner': {
    description: 'Series Producer, or showrunners, have all creative authority and management responsibilities over a show or series, including development, writing, pitching, budgeting and crewing.',
    select: 'Select if you need an experienced producer who can manage and produce a series or show.',
  },
  'Production Coordinator / Crewing': {
    description: 'A coordinating producer in charge of crewing helps find, vet and hire the crew they find on Glimmer. They also may handle pre-produciton, story development or production.',
    select: 'Select if you need an experienced producer who can manage finding, vetting, hiring crew.',
  },
  'Non-Fiction Film Director': {
    description: 'A director for non-fiction video and film handles all aspects of the visualalization and dramatic interpretation of the script, while guiding the technical crew and talent.',
    select: 'Select if you need a director for a film, video or commercial.',
  },
  'Creative Director': {
    description: 'Director who brings artistic sensibilities to complex video projects and typically oversees development and/or production.',
    select: 'Select if you need some extra creative muscle to take your project or production to the next level.',
  },
  'Post-Production Manager': {
    description: 'The post-produciton manager oversees a team of editors to ensure quality and efficient execution of the final video product for any production.',
    select: 'Select if you need someone who can ensure the quality and consistency of a large post-production project.',
  },
  'On-Air Reporter / Host': {
    description: 'On-air talent for hosting news shows or reporting live.',
    select: 'Select if you need polished, professional on-air talent for a production.',
  },
  'Fixer': {
    description: 'Local who can assist securing access to characters, sources and locations.',
    select: 'Select if you need local knowledge or expertise for pre-production research or during your shoot.',
  },
  'Field Producer': {
    description: 'Local journalist who can act as a point person on the ground to help with recruiting local crew and coordinate crew logistics.',
    select: 'Select if you need someone to handle all production-related items during your on-location shoot.',
  },
  'TV News Producer': {
    description: 'Field producer with proven broadcast TV and editorial news experience who can assist your own crew on location.',
    select: 'Select if you have complex logistics and need a single, proven TV producer to coordinate everything on the ground.',
  },
  'Production Assistant': {
    description: 'Professional production assistant who can help your crew on location.',
    select: 'Select if you need another capable hand on deck for a variety of production needs.',
  },
  'Sound Mixer': {
    description: 'Professional sound technician who records audio during a shoot.',
    select: 'Select if you need an audio specialist to guarantee clean, crisp sound.',
  },
  'Gaffer': {
    description: 'Lighting designer for your set or interview.',
    select: 'Select if you need a lighting specialist to help your DP get that perfect shot.',
  },
  'Grip': {
    description: 'Lighting technician or electrician.',
    select: 'Select if you need technical or electrical help for any aspect of the production.',
  },
  'Translator': {
    description: 'Professional translator, able to provide translation services in either verbal or written form.',
    select: 'Select if you need translation on a production or in post-production.',
  },
  'Hair and Make-up Artist': {
    description: 'A hair and make-up artist applies makeup and prosthetics on people for during theatre, television, film, fashion, magazines and other productions.',
    select: 'Select if you need a hair and make-up artist for a shoot.',
  },
  'Video Editor - News': {
    description: 'Professional video editor who knows how to craft, edit, and package news stories or digital media content.',
    select: 'Select if you want an editor who can work on a deadline and deliver a package quickly.',
  },
  'Video Editor - Commercial': {
    description: 'Professional video editor with experience in commercial work.',
    select: 'Select if you need a post production pro to edit your ad spot, commercial or branded video.',
  },
  'Video Editor - Documentary': {
    description: 'Professional video editor with doc editing experience.',
    select: 'Select if you need to an experienced documentary storyteller to craft your narrative in post-production.',
  },
  'Motion Graphics Designer': {
    description: 'Professional designer who can create motion graphics, animations, data visualizations, and on-screen video graphics.',
    select: 'Select if you need any kind of animation or graphics package.',
  },
  'Music Composer': {
    description: 'Musician who creates original scores for video production.',
    select: 'Select if you need to create any custom piece of music or an entire score for your next production.',
  },
  'Sound Designer': {
    description: 'Professional audio creator who handles post-production sound mixing and sound design for videos or animations.',
    select: 'Select if you need to create any custom, original sound for your next production.',
  },
  'Animator / Visual Effects Artist': {
    description: 'VFX artist, or compositor, creates or manipulated imagery and animation in a video or film.',
    select: 'Select if you need an animator or visual effects specialist.',
  },
  'Transcriber': {
    description: 'Transcriber will type out the scripts from any video, film or interview.',
    select: 'Select if you need someone to type out interviews or video dialogue.',
  },
  'Colorist': {
    description: 'A colorist is in charge of color correction or color grading for a film or video.',
    select: 'Select if you need someone to color correct your video, commercial or film.',
  },
  'Editorial Photographer / Photojournalist': {
    description: 'Editorial photographer for news and event coverage.',
    select: 'Select if you need to commission a talented freelance photojournalist.',
  },
  'Event Photographer': {
    description: 'A photographer who cover events, anything from corporate events, to concerts to conferences.',
    select: "Select if you need a photographer to cover an event you're throwing.",
  },
  'Landscape Photographer': {
    description: 'Landscape or travel photographers capture the world from afar or close up, used mostly to showcase nature, travel destinations or mandmade objects for media, advertising or PR.',
    select: 'Select if you need a photographer to capture images of a location or destination.',
  },
  'Portrait Photographer': {
    description: 'A portrait photographer, or portraiture, is a specialist in using lighting, backdrops and poses to capture the personality of the subject.',
    select: 'Select if you need a someone to capture the personality of a subject thorugh photography.',
  },
  'Product Photographer': {
    description: 'A product photographer is a specialist in attractively displaying products for catalogues, brochures or online distribution.',
    select: 'Select if you need photographs that showcase your product beautifully.',
  },
  'Fashion Photographer': {
    description: 'A photographer focused on capturing images that display clothing or fashion items for advertising, PR or fashion publications.',
    select: 'Select if you need a photographer for a fashion or beauty shoot.',
  },
  'Mobile Journalist / Livestreamer': {
    description: 'Professional multimedia journalist with experience covering events or news stories with a smartphone.',
    select: 'Select if you need a storytellers to tell your story for a mobile audience.',
  },
  'HD Live Operator': {
    description: 'HD camera operator with live transmission equipment such a BGAN, satellite phone or LiveU.',
    select: 'Select if you want someone with a premium camera connected to a live feed.',
  },
  'Full-Service Live Production': {
    description: 'Production company specializing in live streaming videos who can handle all aspects of production and delivery.',
    select: 'Select if you want to be more hands off and just get livestreams.',
  },
  '360 Documentary Video': {
    description: 'Professional filmmaker who can shoot cinematic 360 videos that require preparation ahead of time.',
    select: 'Select if you need someone to help craft a narrative with 360 footage.',
  },
  '360 Commercial Video': {
    description: 'Professional filmmaker who can handle the highest quality of 360 videos in the field or on set.',
    select: 'Select if you want someone who has experience working with brands and deliver the highest possible quality footage.',
  },
  '360 News Video': {
    description: 'Professional filmmaker or video journalist with equipment and experience in capturing 360 video in news situation.',
    select: 'Select if you need quick turnaround and need news experience.',
  },
  'Immersive/Spatial Video Capture': {
    description: 'Production companies specializing in 360 who can handle all aspects of production and deliver a video ready to publish.',
    select: 'Select if you just want to be more hands off and just need a finished, amazing 360 video or virtual reality production.',
  },
  'Reporter / Journalist': {
    description: 'Journalist who can write an article or provide research services for development.',
    select: 'Select if you need a great writer or intelligent researcher for any type of project.',
  },
  'Copywriter': {
    description: 'A copywriters is a specialist in writing for the purpose of advertising or marketing.',
    select: 'Select if you need a writer for advertising or marketing.',
  },
  'Copy Editor': {
    description: "An editor who focuses on reviewing and correcting written text for accuracy, clarity and consistency. A copy editor doesn't typically make editorial decisions but may send back suggestions.",
    select: "Select if you need an editor to make sure you're copy is accurate and consistent.",
  },
  'Audio Storyteller': {
    description: 'Audio / radio reporter for audio stories, podcasts, or VR re-enactmanents.',
    select: 'Select if you need a professional freelance radio reporter or podcaster.',
  },
  'Podcast Producer': {
    description: 'A podcast producer acts as an administrator and technical director of a podcast. They manage the production, recording and editing of the scenes and other production staff.',
    select: '',
  },
  'Social Media Producer': {
    description: 'A social media producer works with clients to create, schedule, pitch and distribute relevant content through social media platforms and online media.',
    select: '',
  },
  'Content Strategist': {
    description: 'A content strategist works to understand business goals and user needs, then the planning for the creation, delivery, and distribution strategy for the client.',
    select: '',
  },
  'Executive Producer': {
    description: 'A highly experienced producer and leader who can manage all aspects of production, branding, design, along with editorial and creative direction for a full campaign or large content initiative.',
    select: '',
  },
  'Senior Editor': {
    description: 'A highly experienced editor for written content who can lead an editorial intiative, work with writers and execute larger or ongoing written initiatives for clients.',
    select: '',
  },
  'Digital Content Creator': {
    description: 'A producer of photos, video and written content for distribution on social media using tools provided by platforms to build and engage audiences.',
    select: '',
  },
  'Typographer': {
    description: 'A person that designs the form and arrangement of type to make the written word more legible and aesthetically pleasing. They may design a font, or define the point size, kerning, and other characteristics of a typeface.',
    select: '',
  },
  'Illustrator': {
    description: 'An artist who specializes in enhancing writing or ideas by creating a visual representation of the creative vision of the project.',
    select: '',
  },
  'Graphic Designer': {
    description: 'A graphic designer is a professional who assembles together images, typography, or motion graphics to create a piece of design.',
    select: '',
  },
  'Storyboard Artist': {
    description: 'An artist who works with producers and directors to create storyboards that visualize each frame of the video or film.',
    select: '',
  },
  'Art Director': {
    description: 'A director who works with creative teams to determine the artistic elements and vision, review and approve copy, designs or photography and develop develop budgets and timelines for a project.',
    select: '',
  },
  'On-Camera Talent': {
    description: 'An actor or on-screen performer who can deliver a performance to communicate a specific narrative.',
    select: '',
  },
  'Wardrobe Stylist': {
    description: 'A fashion consultant who selects clothing for a project/event.',
    select: '',
  },
  'VR / AR': {
    description: 'A Virtual Reality professional works with immersive experiences that replace a real-life environment with a simulated one. An Augmented reality professional augments your surroundings by adding digital elements to a live view, often by using the camera on a smartphone.',
    select: '',
  },
  'Metaverse': {
    description: 'A Metaverse professional works in a virtual-reality space where users can interact with a computer generated environment and other users.',
    select: '',
  },
  'Influencer': {
    description: 'A social media personality who has built a reputation and following for their expertise on a specific topic.',
    select: '',
  },
};

export const SERVICES_ELIGIBLE_FOR_SELECT = {
  '84': 'Creative Director',
  '87': 'Production Company',
  '103': 'Line Producer / On-Location',
  '104': 'Senior Producer / Project Manager',
  '105': 'Series Producer / Show Runner',
  '106': 'Production Coordinator / Crewing',
  '107': 'Non-Fiction Film Director',
  '108': 'Post-Production Manager',
  '120': 'Podcast Producer',
  '121': 'Social Media Producer',
  '122': 'Content Strategist',
  '123': 'Executive Producer',
  '124': 'Senior Editor',
};
